if (!customElements.get('custom-faq-section')) {
  class CustomFaqSection extends HTMLElement {
    constructor() {
      super();
      this.resizeTimer = null;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const content = item.querySelector('[data-faq-content]');
        const isOpen = item.classList.contains('active');

        if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (content) {
          content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
        }
      });

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');

        if (!trigger) return;

        trigger.addEventListener('click', () => {
          this.toggleItem(item);
        });

        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleItem(item);
          }
        });
      });

      window.addEventListener('resize', this.handleResize);
    }

    toggleItem(item) {
      const isOpen = item.classList.contains('active');

      this.items.forEach((otherItem) => {
        if (otherItem !== item) this.closeItem(otherItem);
      });

      if (isOpen) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    openItem(item) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');

      if (!content) return;

      item.classList.add('active');

      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      content.style.maxHeight = content.scrollHeight + 'px';
    }

    closeItem(item) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');

      if (!content) return;

      item.classList.remove('active');

      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      content.style.maxHeight = '0px';
    }

    handleResize() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.items.forEach((item) => {
          if (!item.classList.contains('active')) return;

          const content = item.querySelector('[data-faq-content]');

          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        });
      }, 100);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  customElements.define('custom-faq-section', CustomFaqSection);
}